import { HomePosterSoftInk } from './HomePosterSoftInk.js'

// The ONE secondary caption of a home-board POSTER ("projects", "open
// tasks", "due today", …) — the small label under a poster's big numeral.
// Sixteen widget bodies in pages/main.js carried the same four lines with
// `opacity: '0.55'` on the inherited poster ink; that was the blanket
// secondary step nobody had measured — on a saturated hue it read at
// 1.9–3.5:1, under the 4.5:1 AA text floor (tickets/fable.md
// HOME-POSTER-BRAND-1, measured 2026-08-19). The caption now takes the
// poster's MEASURED secondary ink (`homeWidgetHue(...).inkSoft`, the
// smallest alpha of the binary ink that clears ≥4.6:1 on that hue), so it
// can never drift from the header Subtitle again, and it follows a
// branded workspace's poster override exactly like every other ink on the
// card (the token resolves at paint time off `--color-poster<Family>Ink`).
//
// The ink itself comes from `posterSoftInk` (components/HomePosterSoftInk.js),
// the ONE resolver every poster secondary — caption AND body row — shares
// since HOME-POSTER-EMPTYSTATE-INK-1; see that file for how it finds the
// card's poster and what it returns outside one.
export const HomePosterCaption = {
  tag: 'span',
  fontSize: 'Z',
  fontWeight: '400',
  color: HomePosterSoftInk.color
}
